import { createAsyncThunk } from '@reduxjs/toolkit';
import { MapBox } from 'applicaiton/constants/actions';
import { fetchAllLocations } from 'integration/api/mapBox';
import { AxiosError } from 'axios';
import { FetchLocationParams } from 'common/types/mapBox';

/**
 * Asynchronously fetches all locations based on the provided parameters.
 *
 * @param params - The parameters for fetching locations, including query and limit.
 * @returns A Promise that resolves to the fetched location data or rejects with an error message.
 */
export const fetchLocations = createAsyncThunk(
  MapBox.fetchLocation,
  async (params: FetchLocationParams, { rejectWithValue }) => {
    try {
      const { data } = await fetchAllLocations(params);
      return data;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);
